module.exports = __webpack_public_path__ + "img/LUB00412.c235e2a8.svg";